import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import palette from '../../../lib/styles/palette';
import {
  inputNumberAutoComma,
  categoryMapMatcher,
  inputNumberRemoveComma,
} from '../../../lib/commonFunc/commonFunc';
import defaultProfile from '../../../resources/images/common/default_user.png';
import TimeInput from '../../common/TimeInput'
import { AiFillCheckCircle, AiOutlineCheckCircle, AiFillQuestionCircle } from 'react-icons/ai';
import { HiCheck } from 'react-icons/hi';
import { MdClose, MdSwapHoriz, MdDragHandle } from 'react-icons/md';
import TypeChangeInputModal from '../../common/DeleteInputModal';

const Wrapper = styled.div`
    width: 100%;
    padding: 0 10px;
`;

const SettingWrap = styled.div`
    width: 100%;
`;

const SettingBox = styled.div`
  width: 100%;
  margin-bottom: 100px;

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
`;

const SettingTitle = styled.div`
  display: flex;
  align-items: flex-end;
  font-size: 1.1rem;
  justify-content: flex-start;
  font-weight: bold;
  color: rgba(0, 0, 0, .7);
  margin-bottom: 30px !important;

  & span {
    font-weight: normal;
    font-size: .9rem;
    color: rgba(0, 0, 0, .7) !important;
    margin-left: 20px;
  }

  & div.title-box {
    margin-right: 10px;
    width: 10px;
    height: 20px;
    background-color: ${palette.webCyan[5]};
    border-radius: .1rem;
    color: rgba(0, 0, 0, .7) !important;
  }
`;


const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .35);
  z-index: -1;
`;

const SettingCheckBoxWrap = styled.div`
display: flex;
align-items: center;
padding: 5px 0 5px 24px;

& span {
    color: rgba(0, 0,0 , .7);

  & input {
    border: 0;
    border-bottom: 1px solid rgba(0, 0, 0, .2);
    width: 50px;
    font-size: 1rem;
    text-align: center;
    color: rgba(0, 0,0 , .7);

    &:focus {
      outline: none;
    }
  }
}

& div {
  display: flex;
  align-items: center;
  font-size: 1rem;
  margin-right: 30px;
    cursor: pointer;

  &.defaultCursor {
    cursor: default;
  }

  &:nth-last-child(1) {
    margin-right: 0px;
  }

  & svg {
    font-size: 1.9rem;
    color: ${palette.webGray[6]};
    margin-right: 10px;
    
    &.active {
      color: ${palette.webCyan[5]};
    }

  }
}
`;

const SettingTimeWrap = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 5px 24px;

  & div {
    &:nth-child(1) {
      margin-right: 30px;
    }

    &.time {
      display: flex;
      width: 100px;
      align-items: center;
    }
  }
`;

const SettingBtnBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const BtnSetting = styled.button`
  width: 150px;
  padding: 10px 0;
  border-radius: .2rem;
  border: 0;
  background-color: rgba(0, 0, 0, .2);
  cursor: pointer;

  &:nth-child(1) {
    background-color: ${palette.webCyan[5]};
    margin-right: 15px;
    color: #fff;
  }

  &:focus{
    outline: none;
  }
`;

const CoachSelectTitle = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  cursor: default !important;
  color: rgba(0, 0, 0, .7);
`;

const CoachSelectBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: .2rem;
  padding: 5px 15px;
  min-height: 51px;
  min-width: 100%;
  cursor: default !important;
  transition: background 0.2s ease, border-color 0.2s ease;

  &.ordering {
    background: rgba(26, 115, 233, 0.04);
    border: 1px dashed rgba(26, 115, 233, 0.45);
    border-radius: .5rem;
    padding: 4px 14px;
  }
`;


const CoachImage = styled.div`
  position: relative;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
  margin-top: 15px;
  background-position: center top;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,.1);

  ${(props) =>
    props.profile || props.clubProfile
          ? (props.clubProfile ? css`
              background-image: url('https://kr.object.ncloudstorage.com/qnoss/ClubMemberProfile/${props.clubProfile}');
              background-size: cover;
              cursor: pointer;
            `
            :
            (props.profile.indexOf('http') == -1? css`
              background-image: url('https://kr.object.ncloudstorage.com/qnoss/UserProfile/${props.profile}');
              background-size: cover;
              cursor: pointer;
            ` : css`
              background-image: url('${props.profile}');
              background-size: cover;
              cursor: pointer;
            `))
          : css`
              background-image: url(${defaultProfile});
              background-size: cover;
            `}
`;

const CoachItem = styled.div`
  position: relative;
  border-radius: .2rem;
  background-color: none;
  padding: 5px 10px;
  margin: 5px 5px;
  cursor: pointer !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:hover {

    & .photo {
      opacity: .5;
    }

    & svg {
      opacity: 1;
      font-size: 2.3rem;
      margin-right: 0;
      color: ${palette.webCyan[5]};
    }
  }

  & .name {
    color: rgba(0, 0, 0, .7);
  }

  & svg {
    opacity: 0;
  }

  &.ordering {
    cursor: default !important;
  }
  &.ordering:hover .photo {
    opacity: 1;
  }
`;

const LessonMembershipSettingHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 10px;
  width: 100% !important;
  cursor: default !important;
  border: 1px solid rgba(0, 0, 0, .2);
  background-color: rgba(0, 0, 0, .03);
  border-top-left-radius: .2rem;
  border-top-right-radius: .2rem;
  font-weight: bold;
  color: rgba(0, 0, 0, .8);

  & div {
    cursor: default !important;
    padding: 5px 5px;
    margin-right: 0 !important;
  }

  & .title {
    display: block;
    width: 35%;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & .category {
    display: block;
    width: 15%;
    text-align: center;
  }

  & .price {
    display: block;
    width: 20%;
    text-align: center;
  }

  & .count {
    display: block;
    width: 10%;
    text-align: center;
  }

  & .lessonTime {
    display: block;
    width: 20%;
    text-align: center;
  }

  & .totalCancelCount {
    display: block;
    width: 20%;
    text-align: center;
  }
`;

const LessonMembershipSettingList = styled.div`
  display: block !important;
  border: 1px solid rgba(0, 0, 0, .2);
  border-top: 0;
  border-bottom-left-radius: .2rem;
  border-bottom-right-radius: .2rem;
  width: 100% !important;
  height: 300px;
  overflow: overlay;
  &::-webkit-scrollbar {
      width: 10px;
  }
  &::-webkit-scrollbar-thumb {
  background-color: ${palette.webGray[4]};
  border-radius: 10px;
  background-clip: padding-box;
  border: 2px solid transparent;
  }
  &::-webkit-scrollbar-track {
  background-color: ${palette.webGray[2]};
  border-radius: 10px;
  box-shadow: inset 0px 0px 5px white;
  }
`;

const MembershipSettingInput = styled.input`
  border: 0;
  border-bottom: 1px solid ${palette.webCyan[5]};
  width: 50px;
  padding: 3px 5px;
  margin-right: 10px;
  text-align: center;

  &.disabled {
    border: 0;
  }

  &:focus {
    outline: none;
  }
`;

const LessonMembershipSettingItem = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 10px;
  cursor: default !important;
  width: 100% !important;
  color: rgba(0, 0, 0, .8);
  border-bottom: 1px solid rgba(0, 0, 0, .05);

  &:nth-last-child(1) {
    border-bottom: 0;
  }

  & div {
    cursor: default !important;
    padding: 5px 5px;
    margin-right: 0 !important;
  }

  & .title {
    display: block;
    width: 35%;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & .category {
    display: block;
    width: 15%;
    text-align: center;
  }

  & .price {
    display: block;
    width: 20%;
    text-align: center;
  }

  & .count {
    display: block;
    width: 10%;
    text-align: center;
  }

  & .lessonTime {
    display: block;
    width: 20%;
    text-align: center;
  }

  & .totalCancelCount {
    display: block;
    width: 20%;
    text-align: center;
  }
`;

const LessonTypeSelectBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 0 20px;
`;

const LessonTypeSelectItem = styled.div`
  overflow: hidden;
  border-radius: .4rem;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, .12);
  border: 1px solid rgba(0, 0, 0, .1);
  cursor: pointer;

  &:hover {
    box-shadow: 0px 4px 8px 0px rgba(26, 115, 233, .15);
    border: 1px solid rgba(26, 115, 233, .5);
    transition: 1s;
  }

  &.active {
    box-shadow: 0px 4px 8px 0px rgba(26, 115, 233, .35);
    border: 1px solid ${palette.webCyan[5]};
    transition: 1s;
  }
`;

const LessonTypeSelectItemHeader= styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient( to bottom, #558ACF, #629EEE );
  font-size: 1.2rem;
  height: 100px;

  & .type {
    font-size: 1.8rem;
    font-weight: bold;
    padding-top: 5px;
  }
`;

const LessonTypeSelectItemBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 35px 25px;
  color: rgba(0, 0, 0, .7);
  height: 480px;

  & .content {
    font-size: 1.1rem;
    font-weight: bold;
    text-align: center;
    line-height: 150%;
  }

  & .info {
    width: 100%;
    font-size: .95rem;
    text-align: center;
    margin-bottom: 20px;
    line-height: 150%;
  }

  & .intro-box {
    width: 100%;

    & .title {
      font-weight: bold;
      margin-bottom: 10px;
    }

    & ul.using {
      width: 100%;

      & svg {
        color: #75CB80;
        font-size: 1.3rem;
      }

      & li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom:  5px;

        &:nth-last-child(1) {
          margin-bottom:  0px;
        }

        & div:nth-child(1) {
          padding-left: 10px;
        }
      }
    }

    & ul.unusing {
      width: 100%;

      & svg {
        color: #FF8080;
        font-size: 1.3rem;
      }

      & li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom:  5px;

        &:nth-last-child(1) {
          margin-bottom:  0px;
        }

        & div:nth-child(1) {
          padding-left: 10px;
        }
      }
    }

  }
`;
const MembershipSettingModalWrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  z-index: 998;

  @media screen and (max-width: 720px) {
    width: 100%;
    height: 100%;
  }
`;

const MembershipSettingBox = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #fff;
  border-radius: .2rem;
  

  @media screen and (max-width: 720px) {
      position: absolute;
      top: 180px;
  }
`;

const MembershipSettingBtnBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: 1px solid rgba(0, 0, 0, .2);
  padding: 15px 30px 15px 30px;
`;

const BtnMembershipSettingDelete = styled.button`
  width: 120px;
  padding: 5px 0;
  background-color: ${palette.warning};
  color: #fff;
  font-size: 1rem;
  border: 0;
  border-radius: .2rem;
  cursor: pointer;
  margin-left: 350px;

  &:focus {
    outline: none;
  }
`;

const BtnMembershipSettingConfirm = styled.button`
  width: 120px;
  padding: 5px 0;
  background-color: ${palette.webCyan[5]};
  color: #fff;
  font-size: 1rem;
  border: 0;
  border-radius: .2rem;
  cursor: pointer;
  margin-right: 20px;

  &:focus {
    outline: none;
  }
`;

const BtnMembershipSettingClose = styled.button`
width: 120px;
padding: 5px 0;
background-color: ${palette.webGray[5]};
color: #fff;
font-size: 1rem;
border: 0;
border-radius: .2rem;
cursor: pointer;

&:focus {
  outline: none;
}
`;

const MembershipSettingTitle = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  background-color: ${palette.webCyan[5]};
  color: #fff;
  font-size: 1.3rem;
  font-weight: bold;
  border-top-left-radius: .2rem;
  border-top-right-radius: .2rem;
`;

const MembershipSettingContentBox = styled.div`
  width: 1200px;
  height: auto;
  padding: 25px 30px 30px 30px;
`;

const LessonMembershipTap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 12px;
`;

const Tap = styled.div`
  cursor: pointer;
  font-size: 1.1rem !important;
  color: rgba(0, 0, 0, .3);
  font-weight: bold;

  &:nth-child(1) {
    margin-right: 20px;
  }

  &.active {
    color: rgba(0, 0, 0, .7);
  }
`;

const InfoHover = styled.div `

  & svg {
    position: absolute;
    bottom: -2px;
    left: 10px;
    font-size: 1.7rem;
    color: ${palette.webGray[16]};
  }

  & .info {
    display: none !important;
  }

  &:hover .info {
    display: flex !important;
  }
`

const SettingTab = styled.ul`
  border-radius: .2rem;
  width: fit-content;
  overflow: hidden;
  border: 1px solid #CFCFCF;
  display: flex;
  align-items: center;

  & li {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4d4d4d;
    font-size: 1rem;
    background-color: #fff;
    width: 200px;
    border-right: 1px solid #CFCFCF;
    cursor: pointer;
    height: 40px;

    &:nth-last-child(1) {
      border: 0;
    }

    &.active {
      color: #ffffff;
      background-color: #468AE3;
    }
  }
`;

const CoachOrderControl = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 6px;
  justify-content: center;
`;

const OrderBtn = styled.button`
  width: 26px;
  height: 26px;
  border: 1px solid ${palette.webGray[4]};
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.78rem;
  line-height: 1;
  color: ${palette.webGray[8]};
  padding: 0;
  transition: all 0.15s ease;
  &:hover:not(:disabled) { border-color: ${palette.webCyan[5]}; color: ${palette.webCyan[5]}; background: rgba(26, 115, 233, 0.06); }
  &:disabled { opacity: 0.3; cursor: default; }
  &:focus { outline: none; }
`;
const CoachSelectHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
`;
const OrderToggleBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.active ? palette.webCyan[5] : palette.webGray[4])};
  background: ${(p) => (p.active ? palette.webCyan[5] : '#fff')};
  color: ${(p) => (p.active ? '#fff' : palette.webGray[7])};
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  & svg { font-size: 1.15rem; }
  &:hover {
    border-color: ${palette.webCyan[5]};
    box-shadow: 0 2px 8px rgba(26, 115, 233, 0.15);
  }
  &:focus { outline: none; }
`;
const OrderHint = styled.div`
  width: 100%;
  margin: 0 0 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  color: ${palette.webCyan[5]};
  & svg { font-size: 1rem; flex-shrink: 0; }
`;
const OrderBadge = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  min-width: 22px;
  height: 22px;
  padding: 0 5px;
  border-radius: 11px;
  background: ${palette.webCyan[5]};
  color: #fff;
  font-size: 0.76rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.22);
  z-index: 2;
`;
const OrderModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 1100;
  background: rgba(17, 24, 39, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const OrderModalCard = styled.div`
  width: 480px;
  max-width: 92vw;
  max-height: 84vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
`;
const OrderModalHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 20px 22px;
  border-bottom: 1px solid ${palette.webGray[2]};

  & h3 { margin: 0; font-size: 1.12rem; font-weight: 800; color: ${palette.webGray[8]}; }
  & .close {
    display: inline-flex; align-items: center; justify-content: center;
    width: 32px; height: 32px; border: none; background: transparent;
    color: ${palette.webGray[6]}; font-size: 1.4rem; cursor: pointer; border-radius: 8px;
    transition: all 0.15s ease;
    &:hover { background: ${palette.webGray[1]}; color: ${palette.webGray[8]}; }
    &:focus { outline: none; }
  }
`;
const OrderModalBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 16px;
`;
const OrderGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
const OrderCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  padding: 12px 8px 10px;
  border-radius: 12px;
  border: 1px ${(p) => (p.dragging ? 'dashed' : 'solid')} ${(p) => (p.dragging ? palette.webCyan[5] : palette.webGray[2])};
  background: ${(p) => (p.dragging ? 'rgba(26, 115, 233, 0.10)' : '#fff')};
  opacity: ${(p) => (p.dragging ? 0.6 : 1)};
  cursor: grab;
  user-select: none;
  transition: border-color 0.12s ease, background 0.12s ease, opacity 0.12s ease;
  &:active { cursor: grabbing; }

  & .name {
    margin-top: 8px;
    font-size: 0.86rem;
    color: ${palette.webGray[8]};
    font-weight: 600;
    max-width: 100%;
    text-align: center;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    pointer-events: none;
  }
  & .handle {
    margin-top: 8px;
    font-size: 1.25rem;
    color: ${palette.webGray[5]};
    pointer-events: none;
  }
`;
const DragHint = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 2px 2px 12px;
  font-size: 0.84rem;
  color: ${palette.webGray[6]};
  & svg { font-size: 1.05rem; color: ${palette.webCyan[5]}; }
`;
const OrderDesc = styled.div`
  margin: 0 2px 16px;
  padding: 12px 14px;
  border-radius: 10px;
  background: ${palette.webGray[0]};
  border: 1px solid ${palette.webGray[2]};
  font-size: 0.82rem;
  line-height: 1.75;
  color: ${palette.webGray[7]};
  & p { margin: 0; display: flex; gap: 6px; }
  & p .dot { color: ${palette.webCyan[5]}; font-weight: 700; }
  & b { color: ${palette.webCyan[5]}; font-weight: 700; }
  & .warn { color: #e2554e; font-weight: 700; }
`;
const OrderModalFooter = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 10px;
  padding: 14px 18px 18px;
  border-top: 1px solid ${palette.webGray[2]};
`;
const CancelBtn = styled.button`
  height: 44px;
  padding: 0 18px;
  border-radius: 10px;
  border: 1px solid ${palette.webGray[4]};
  background: #fff;
  color: ${palette.webGray[7]};
  font-size: 0.95rem; font-weight: 600; cursor: pointer;
  transition: all 0.15s ease;
  &:hover { background: ${palette.webGray[1]}; }
  &:focus { outline: none; }
`;
const ApplyBtn = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 10px;
  border: none;
  background: ${palette.webCyan[5]};
  color: #fff;
  font-size: 0.97rem; font-weight: 700; cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 6px 16px rgba(26, 115, 233, 0.3);
  &:hover { filter: brightness(0.96); }
  &:focus { outline: none; }
`;

const DefaultSetting = ({
  coach,
  activeCoachList, 
  invalidCoachList, 
  setActiveCoachList, 
  setInvalidCoachList,
  coachScheduleType,
  setCoachScheduleType,
  lessonType,
  startHour,
  setStartHour,
  endHour,
  setEndHour,
  modifySetting
}) => {

  // 강사 순서 변경 모달 — draftOrder 로 임시 편집 후 '적용' 시 activeCoachList 에 반영
  // (저장 자체는 페이지 하단 [저장] 버튼의 modifySetting 에서 join('%&') 으로 영속)
  const [orderModalOpen, setOrderModalOpen] = useState(false)
  const [draftOrder, setDraftOrder] = useState([])
  const [dragIndex, setDragIndex] = useState(null)

  const openOrderModal = () => {
    setDraftOrder([...activeCoachList])
    setOrderModalOpen(true)
  }
  const applyOrder = () => {
    setActiveCoachList(draftOrder)
    setOrderModalOpen(false)
  }
  // 드래그하는 동안 실시간으로 순서를 재배치 → 드래그한 카드를 hover 한 카드 위치로 즉시 이동
  // (순서가 바뀌는 것을 드래그 중에 바로 보여줌. 순번 배지도 즉시 갱신)
  const onCardDragEnter = (idx) => {
    if (dragIndex === null || idx === dragIndex) return
    const next = [...draftOrder]
    const [moved] = next.splice(dragIndex, 1)
    next.splice(idx, 0, moved)
    setDraftOrder(next)
    setDragIndex(idx)
  }
  const endDrag = () => setDragIndex(null)

  return (
    <>
        <SettingWrap style={{marginTop: '80px'}}>
            {/* 강사 설정 */}
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '30px'}}>
              <div style={{marginRight: '20px', color: 'rgba(0, 0, 0, .5)', fontWeight: 'bold'}}>강사 설정</div>
              <div style={{flex: 1, height:' 49%', borderBottom: '1px solid rgba(0, 0, 0, .2)'}}/>
            </div>
            <SettingBox>
                <SettingTitle style={{marginBottom: '10px'}}>
                    <div className="title-box"></div>
                    레슨 강사를 등록해주세요. <span>* 레슨 강사에 등록되어야 레슨 기능을 사용할 수 있습니다.</span>
                </SettingTitle>
                <SettingCheckBoxWrap style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                  <CoachSelectHeader>
                    <CoachSelectTitle style={{marginBottom: 0}}>레슨 강사</CoachSelectTitle>
                    {activeCoachList && activeCoachList.length >= 2 &&
                      <OrderToggleBtn type="button" onClick={openOrderModal}>
                        <MdSwapHoriz /> 순서 변경
                      </OrderToggleBtn>
                    }
                  </CoachSelectHeader>
                  <CoachSelectBox style={{marginBottom: '30px', marginRight: 0}}>
                    {activeCoachList && activeCoachList.map((coachID, idx) => {
                      const item = coach && coach.find(c => {return c.playerID == coachID})
                      if(!item) return null
                      return(
                        <CoachItem className="active" key={coachID} onClick={
                          () => {
                            let activeCoachArr = activeCoachList.filter(coach => {return item.playerID != coach})
                            let invalidCoachArr = []

                            for (let i = 0; i < invalidCoachList.length; i++) {
                              invalidCoachArr.push(invalidCoachList[i])
                            }

                            invalidCoachArr.push(item.playerID)
                            setActiveCoachList(activeCoachArr)
                            setInvalidCoachList(invalidCoachArr)
                          }
                        }>
                          <CoachImage className="photo" style={{marginRight: 0}} profile={item && item.profileURL} clubProfile={item && item.clubProfileURL}></CoachImage>
                          <div className="name">{item.name}</div>
                        </CoachItem>
                      )
                    })}
                    {activeCoachList && activeCoachList.length == 0 && <div style={{width: '100%', display: 'flex', height:'80px',justifyContent: 'center', alignItems: 'center', color: 'rgba(0, 0, 0, .5)', fontSize: '.95rem'}}>레슨 강사를 등록해주세요.</div>}
                  </CoachSelectBox>
                  <CoachSelectTitle>클럽에 등록 되어있는 강사</CoachSelectTitle>
                  <CoachSelectBox>
                    {coach && coach.filter(item => {return invalidCoachList.includes(item.playerID)}).map((item, idx) => {
                      return(
                        <CoachItem key={idx} onClick={
                          () => {
                            let invalidCoachArr = invalidCoachList.filter(coach => {return item.playerID != coach})
                            let activeCoachArr = []

                            for (let i = 0; i < activeCoachList.length; i++) {
                              activeCoachArr.push(activeCoachList[i])
                            }

                            activeCoachArr.push(item.playerID)
                            
                            setActiveCoachList(activeCoachArr)
                            setInvalidCoachList(invalidCoachArr)
                          }
                        }>
                          <CoachImage className="photo" style={{marginRight: 0}} profile={item && item.profileURL} clubProfile={item && item.clubProfileURL}></CoachImage>
                          <div className="name">{item.name}</div>
                        </CoachItem>
                      )
                    })}
                    {invalidCoachList && invalidCoachList.length == 0 && <div style={{width: '100%', display: 'flex', height:'80px',justifyContent: 'center', alignItems: 'center', color: 'rgba(0, 0, 0, .5)', fontSize: '.95rem'}}>일반 강사가 없습니다.</div>}
                  </CoachSelectBox>
                </SettingCheckBoxWrap>
            </SettingBox>
            <SettingBox>
                <SettingTitle style={{marginBottom: '10px'}}>
                    <div className="title-box"></div>
                    강사가 앱에서 서로의 일정을 확인할 수 있도록 하시겠습니까?
                </SettingTitle>
                <SettingCheckBoxWrap>
                  <div>
                    {coachScheduleType == 1 ? <AiFillCheckCircle className="active"/> : <AiOutlineCheckCircle onClick={() => setCoachScheduleType(1)} />}
                    <span onClick={() => {if(coachScheduleType != 1)setCoachScheduleType(1)}}>본인 일정만 확인 가능</span>
                  </div>
                  <div>
                    {coachScheduleType == 2 ? <AiFillCheckCircle className="active"/> : <AiOutlineCheckCircle onClick={() => setCoachScheduleType(2)} />}
                    <span onClick={() => {if(coachScheduleType != 2)setCoachScheduleType(2)}}>모든 강사 일정 확인 가능</span>
                  </div>
                </SettingCheckBoxWrap>
            </SettingBox>
            {/* 시간표 설정 */}
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '30px', position: 'relative'}}>
              <div style={{marginRight: '20px', color: 'rgba(0, 0, 0, .5)', fontWeight: 'bold'}}>기본 설정</div>
              <div style={{flex: 1, height:' 49%', borderBottom: '1px solid rgba(0, 0, 0, .2)'}}/>
            </div>
            <SettingBox>
                <SettingTitle style={{marginBottom: '10px'}}>
                    <div className="title-box"></div>
                    레슨 시간표의 시작 시간과 종료 시간을 선택해주세요.
                </SettingTitle>
                <SettingTimeWrap>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <span style={{cursor: 'default', marginRight: '30px'}}>시작 시간</span>
                    <div className="time">
                      <div style={{marginRight: '10px'}}>
                          <TimeInput 
                              value={startHour}
                              setValue={setStartHour}
                              type="hour"
                          />
                      </div>
                      <div style={{marginRight: '10px'}}>
                      시
                      </div>
                    </div>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <span style={{cursor: 'default', marginRight: '30px'}}>종료 시간</span>
                    <div className="time">
                      <div style={{marginRight: '10px'}}>
                          <TimeInput 
                              value={endHour}
                              setValue={setEndHour}
                              type="hour"
                          />
                      </div>
                      <div style={{marginRight: '10px'}}>
                      시
                      </div>
                    </div>
                  </div>
                </SettingTimeWrap>
            </SettingBox>
        </SettingWrap>
        {orderModalOpen &&
          <OrderModalOverlay onClick={() => setOrderModalOpen(false)}>
            <OrderModalCard onClick={(e) => e.stopPropagation()}>
              <OrderModalHeader>
                <h3>강사 순서 변경</h3>
                <button type="button" className="close" aria-label="닫기" onClick={() => setOrderModalOpen(false)}><MdClose /></button>
              </OrderModalHeader>
              <OrderModalBody>
                <DragHint><MdDragHandle /> 카드를 드래그하여 순서를 변경하세요.</DragHint>
                <OrderDesc>
                  <p><span className="dot">·</span> 정한 순서가 <b>레슨 화면의 강사 나열 순서</b>가 됩니다. (왼쪽부터 1번)</p>
                  <p><span className="dot">·</span> 카드의 <b>번호</b>가 실제 표시 순서입니다.</p>
                </OrderDesc>
                <OrderGrid>
                  {draftOrder.map((coachID, idx) => {
                    const item = coach && coach.find(c => {return c.playerID == coachID})
                    if(!item) return null
                    return (
                      <OrderCard
                        key={coachID}
                        draggable
                        dragging={dragIndex === idx}
                        onDragStart={(e) => { setDragIndex(idx); if(e.dataTransfer){ e.dataTransfer.effectAllowed = 'move'; try { e.dataTransfer.setData('text/plain', String(idx)) } catch(err) {} } }}
                        onDragEnter={() => onCardDragEnter(idx)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => { e.preventDefault(); endDrag() }}
                        onDragEnd={endDrag}
                      >
                        <OrderBadge>{idx + 1}</OrderBadge>
                        <CoachImage profile={item && item.profileURL} clubProfile={item && item.clubProfileURL} style={{width: '58px', height: '58px', marginTop: 0, marginBottom: 0, boxShadow: 'none', pointerEvents: 'none'}}></CoachImage>
                        <div className="name">{item.name}</div>
                        <MdDragHandle className="handle" />
                      </OrderCard>
                    )
                  })}
                </OrderGrid>
              </OrderModalBody>
              <OrderModalFooter>
                <CancelBtn type="button" onClick={() => setOrderModalOpen(false)}>취소</CancelBtn>
                <ApplyBtn type="button" onClick={applyOrder}>적용</ApplyBtn>
              </OrderModalFooter>
            </OrderModalCard>
          </OrderModalOverlay>
        }
    </>
  );
};

export default DefaultSetting;
